import PostSearchQuery from './components/post-search-query';

export default PostSearchQuery;
